import { createPinia } from 'pinia';

const pinia = createPinia();

export const appPlugins = {
  pinia,
};
